module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Playlist1-2bc36efb188237ee549a94cd9974f67e.svg";